import { takeLatest, put, call } from 'redux-saga/effects';

import { listVeiculoCadastro } from '../service';
import {
  TABLE_VEICULO_CADASTRO,
  TABLE_VEICULO_CADASTRO_PENDING,
  TABLE_VEICULO_CADASTRO_SUCCESS,
  TABLE_VEICULO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListVeiculoCadastro(action) {
  yield put({ type: TABLE_VEICULO_CADASTRO_PENDING })

  try {
    const table = yield call(listVeiculoCadastro, action.args)
    yield put({ type: TABLE_VEICULO_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_VEICULO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListVeiculoCadastro() {
  yield takeLatest(TABLE_VEICULO_CADASTRO, sagaListVeiculoCadastro)
}